import {
  PlanInternalMessage,
  PlanMeasureKey,
} from "features/CenterContent/RoleContent/EventHandling/components/EventChangesDialog/types";
import { ActionCardInfo } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/ActionCardInfo";
import { CardHeader } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/CardHeader";
import { EventBadges } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/EventBadges";
import { InternalMessageBox } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/InternalMessageBox";
import { useLabelForActionCard } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/useInfraEventCardData";
import { EventCardShell } from "features/CenterContent/RoleContent/EventHandling/components/shared/EventCardShell";
import { FC } from "react";
import { Text } from "shared/components/Spor";
import { InfrastructureOperationalInformationOverviewResponse } from "shared/types/operationalInformation";

type InfraEventCardProps = {
  event: InfrastructureOperationalInformationOverviewResponse;
  internalMessages: PlanInternalMessage[];
  columnEventState?: PlanMeasureKey;
};

const InfraEventCard: FC<InfraEventCardProps> = ({
  event,
  internalMessages,
  columnEventState,
}) => {
  const { actionCardLabel } = useLabelForActionCard(event.actionCard);

  return (
    <EventCardShell
      event={event}
      eventInternalMessages={internalMessages}
      columnEventState={columnEventState}
      eventTitle={event.stretchName || "-"}
    >
      {({
        colorScheme,
        semantics,
        changed,
        notifying,
        canToggleNotify,
        onToggleNotify,
        closed,
      }) => (
        <>
          <CardHeader
            title={<b>{event.stretchName}</b>}
            colorScheme={colorScheme}
            semantics={semantics}
            notifying={notifying}
            onToggleNotify={onToggleNotify}
            showNotifyButton={!changed && canToggleNotify}
          />

          <EventBadges
            eventType={event.type.type}
            eventLabel={event.type.label || ""}
            state={event.state}
          />

          {event.reason?.description?.NOB && (
            <Text
              variant="sm"
              color={colorScheme.textColorMain}
              fontWeight="normal"
            >
              {event.reason.description.NOB}
            </Text>
          )}

          {!closed && (
            <>
              <ActionCardInfo
                actionCardType={event.actionCard?.type}
                actionCardLabel={actionCardLabel || undefined}
                colorScheme={colorScheme}
              />

              <InternalMessageBox
                messages={internalMessages || []}
                semantics={semantics}
                colorScheme={colorScheme}
              />
            </>
          )}
        </>
      )}
    </EventCardShell>
  );
};

export default InfraEventCard;
